<template>
  <Modal v-model="model" :title="title" @on-cancel="cancel" sticky reset-drag-position footer-hide :mask="false" draggable scrollable
         class="knowledge_pop insert_edit_pop" width="800">
    <div class="knowledge_input insert_edit_template">
      <div class="insert_edit_input" style="width: 40%">
        <div class="font_style_set"><span class="span_must">*</span>类目</div>
        <Select v-model="baseId" placeholder="请选择上级类目" title="请选择上级类目">
          <Option v-for="(option, index) in baseIdNameList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="insert_edit_input" style="width: 40%">
        <div class="font_style_set"><span class="span_must">*</span>标题</div>
        <Input v-model="tittle" placeholder="请输入标题" title="标题"/>
      </div>
      <div class="insert_edit_input" style="width: 20%">
        <div class="font_style_set" style="width: 25%;">置顶</div>
        <Select v-model="isUpInt" style="width: 65%;" placeholder="是否置顶" title="请选择是否置顶">
          <Option v-for="(option, index) in isUpList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
    </div>
    <div class="input_style insert_edit_left">
      <div class="font_style_set"><span class="span_must">*</span>知识内容:</div>
      <div class="insert_edit_input" style="padding-top: 5px;">
        <quill-editor class="quill" v-model="content" ref="myQuillEditor" :options="editorOption"
                      :size="6"></quill-editor>
      </div>
    </div>
    <div style="min-height:80px;max-height: 140px; overflow-y: auto;padding-top: 15px;">
      <div v-for="(item , index) in uploadList" :key="index" :id="item.id">
        <div class="insert_edit_template">
          <div class="font_style_set">附件:</div>
          <div class="insert_edit_input">
            <Upload :action="baseUploadUrl" :max-size="15360" :on-exceeded-size="handleMaxSize"
                    :show-upload-list="showUploadList" :on-success="(res,file)=>onSuccess(res,index)"
                    :on-error="uploadFail">
              <Input v-model="item.downName" readonly="readonly" icon="ios-cloud-upload-outline" placeholder="文件上传"/>
            </Upload>
          </div>
          <div v-if="index==0" @click="addUploadData" class="img_div">
            <img class="title_content_btn" src="../../assets/image/uploadAdd.png"/>
          </div>
          <div @click="deleteuploadList(item.id,index)" class="img_div">
            <img class="title_content_btn" src="../../assets/image/uploadDle.png"/>
          </div>
        </div>
        <div class="insert_edit_template">
          <div class="font_style_set" style="line-height: 30px"><span v-show="item.sign=='1'" :id="index+'_span'"
                                                                      class="span_must">*</span>描述:
          </div>
          <div class="insert_edit_input">
            <Input v-model="item.description" placeholder="请输入附件描述"/>
          </div>
        </div>
      </div>
      <div>
        <span class="span_must">文件限制大小15M，描述对应每一个附件，附件为空时，描述失效</span>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {quillEditor, Quill} from 'vue-quill-editor'
  import {container, ImageExtend} from 'quill-image-extend-module'

  Quill.register('modules/ImageExtend', ImageExtend);
  import {publicFunClass} from '@/components/js/PublicFunClass.js'

  export default {
    name: "KnowledgeContentPop",
    mixins: [publicFunClass],
    components: {
      quillEditor
    },
    props: {
      showDataKnlgEdit: Boolean,
      contentId: String,
      selectTreeIdForContent: String,
      baseIdList: Array,
    },
    data() {
      return {
        fullscreen: false,
        isUpInt: '',
        editorOption: {
          modules: {
            ImageExtend: {},
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],

                [{'header': 1}, {'header': 2}],               // custom button values
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                [{'direction': 'rtl'}],                         // text direction

                [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                [{'header': [1, 2, 3, 4, 5, 6, false]}],

                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                [{'font': []}],
                [{'align': []}],

                ['clean'],                                         // remove formatting button
                ['fullscreen']
              ],  // container为工具栏，此次引入了全部工具栏，也可自行配置
              handlers: {
                fullscreen() {
                  if (!this.fullscreen) {
                    this.fullscreen = true
                    this.quill.container.parentNode.parentNode.className = 'ql-editor ql-blank editor-fullscreen'
                  } else {
                    this.fullscreen = false
                    this.quill.container.parentNode.parentNode.className = 'quill-editor quill'
                  }
                }
              },
            },
          }
        },
        model: false,
        spinShow: true,
        showUploadList: false,
        selected: true,
        showMessage: false,
        tittle: '',
        baseId: '0',
        content: '',
        fileAddr: '',
        description: '',
        journalType: '',
        menuIdL: '',
        absolutePath: '',
        baseIdNameList: [],
        title: '',
        modelHeight: {'maxHeight': '', 'marginTop': '20px'},
        baseUploadUrl: "",
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        isUpList: [{'id': '0', 'name': '否'}, {'id': '1', 'name': '是'}],
        uploadList: [],
        upLoadIndex: -1,
        toolbarTips: [{Choice: '.ql-bold', title: '加粗'}, {Choice: '.ql-italic', title: '倾斜'}, {
          Choice: '.ql-underline',
          title: '下划线'
        }, {Choice: '.ql-header', title: '段落格式'}, {Choice: '.ql-strike', title: '删除线'}, {
          Choice: '.ql-blockquote',
          title: '块引用'
        }, {Choice: '.ql-code-block', title: '插入代码段'}, {
          Choice: '.ql-size',
          title: '字体大小'
        }, {Choice: '.ql-list[value="ordered"]', title: '编号列表'}, {
          Choice: '.ql-list[value="bullet"]',
          title: '项目列表'
        }, {Choice: '.ql-header[value="1"]', title: '标题一'}, {
          Choice: '.ql-header[value="2"]',
          title: '标题二'
        }, {Choice: '.ql-align', title: '对齐方式'}, {Choice: '.ql-color', title: '字体颜色'}, {
          Choice: '.ql-background',
          title: '背景颜色'
        }, {Choice: '.ql-image', title: '图像'}, {Choice: '.ql-video', title: '视频'}, {
          Choice: '.ql-link',
          title: '添加链接'
        }, {Choice: '.ql-formula', title: '插入公式'}, {
          Choice: '.ql-clean',
          title: '清除格式'
        }, {Choice: '.ql-indent[value="-1"]', title: '向左缩进'}, {
          Choice: '.ql-indent[value="+1"]',
          title: '向右缩进'
        }, {
          Choice: '.ql-header .ql-picker-label',
          title: '标题大小'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="1"]',
          title: '标题一'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="2"]',
          title: '标题二'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="3"]',
          title: '标题三'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="4"]',
          title: '标题四'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="5"]',
          title: '标题五'
        }, {
          Choice: '.ql-header .ql-picker-item[data-value="6"]',
          title: '标题六'
        }, {
          Choice: '.ql-header .ql-picker-item:last-child',
          title: '标准'
        }, {
          Choice: '.ql-size .ql-picker-item[data-value="small"]',
          title: '小号'
        }, {
          Choice: '.ql-size .ql-picker-item[data-value="large"]',
          title: '大号'
        }, {
          Choice: '.ql-size .ql-picker-item[data-value="huge"]',
          title: '超大号'
        }, {
          Choice: '.ql-size .ql-picker-item:nth-child(2)',
          title: '标准'
        }, {
          Choice: '.ql-align .ql-picker-item:first-child',
          title: '居左对齐'
        }, {
          Choice: '.ql-align .ql-picker-item[data-value="center"]',
          title: '居中对齐'
        }, {
          Choice: '.ql-align .ql-picker-item[data-value="right"]',
          title: '居右对齐'
        }, {Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐'}, {
          Choice: '.ql-fullscreen',
          title: '全屏'
        },{Choice: '.ql-script[value="sub"]', title: '下标'},{Choice: '.ql-script[value="super"]', title: '上标'},{Choice: '.ql-direction', title: '左右对齐'},{Choice: '.ql-font', title: '字体'}],
      }
    },
    methods: {
      handle: function () {
        // if (! this.fullscreen) {
        // this.fullscreen = true
        // this.editorContainer.className = 'ql-editor ql-blank editor-fullscreen'
        // noScroll.on()
        // }else{
        //   this.fullscreen = false
        // this.editorContainer.className = 'ql-editor ql-blank'
        // noScroll.off()
        // }
      },
      addUploadData: function () {
        let param = {
          downName: "",
          description: ""
        };
        this.uploadList.push(param);
      },
      deleteuploadList: function (id, index) {
        if (!id) {
          this.uploadList.splice(index, 1);
          this.$Message.info("已删除");
          if(this.uploadList.length == 0){
            this.addUploadData();
          }
          return false;
        }
      },
      cancel: function () {
        this.$emit("closeDataKnlgPop", false);
      },
      save: function () {
        if (!this.tittle) {
          this.$Modal.info({
            title: '提示',
            content: "标题不能为空"
          });
          return false;
        }
        if (!this.isUpInt) {
          this.$Modal.info({
            title: '提示',
            content: "请选择是否置顶"
          });
          return false;
        }
        if (!this.content) {
          this.$Modal.info({
            title: '提示',
            content: "请输入知识内容"
          });
          return false;
        }
        let fileAddress = this.fileAddr;
        let description = this.description;
        for (let i = 0; i < this.uploadList.length; i++) {
          if (this.uploadList[i].downName != "" && this.uploadList[i].downName != undefined) {
            if (i == 0) {
              fileAddress = fileAddress + this.uploadList[i].downName;
              description = description + this.uploadList[i].description;
            } else {
              fileAddress = fileAddress + "," + this.uploadList[i].downName;
              description = description + "," + this.uploadList[i].description;
            }
            if (fileAddress != "" && description == "") {
              this.$Modal.info({
                title: '提示',
                content: "请输入附件对应的描述"
              });
              return false;
            }
          }
        }
        let that = this;
        let param = {
          journalType: this.journalType,
          menuId: this.menuId,
          id: this.contentId,
          tittle: this.tittle,
          baseId: this.baseId,
          content: this.content,
          isUp: this.isUpInt,
          fileAddr: fileAddress,
          description: description,
        }
        this.$http.post("knowledge/doSave.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.$Message.info("操作成功");
          that.$emit("closeDataKnlgPop", true);
        });
      },
      initSearch: function (contentId) {
        let that = this;
        let param = {
          id: contentId,
          journalType: "null",
          menuId: "null"
        };
        this.$http.post("knowledge/selectOne.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let list = res.data.obj;
          that.isUpInt = list.isUp + "";
          that.tittle = list.tittle;
          that.baseId = list.baseId + "";
          that.content = list.content;
          if (list.fileAddrs != undefined) {
            that.uploadList = list.fileAddrs;
          }
        });
      },
      onSuccess(res, index) {
        this.$Modal.info({
          title: '提示',
          content: res.msg
        });
        this.uploadList[index].downName = res.obj.absolutePath;
        this.uploadList[index].sign = "1";
      },
      uploadFail() {
        this.$Message.info("上传失败");
      },
      handleMaxSize(file) {
        this.$Modal.info({
          title: '超出文件大小限制',
          content: '文件 ' + file.name + ' 太大，不能超过15M。'
        });
      },
    },
    watch: {
      showDataKnlgEdit: function () {
        this.model = this.showDataKnlgEdit;
        this.baseUploadUrl = this.baseURL + "common/upload.json?type=knowlege&companyNo=" + localStorage.getItem("companyId");
        if (this.showDataKnlgEdit) {
          this.uploadList = [];
          let param = {
            description: "",
            downName: ""
          };
          this.uploadList.push(param);
          this.baseIdNameList = this.baseIdList;
          this.spinShow = true;
          if (this.contentId != null && this.contentId != "") {
            this.title = '编辑知识库内容';
            this.journalType = "知识库管理=>知识库列表=>编辑";
            this.menuId = "6_2-5";
            this.initSearch(this.contentId + "");
          } else {
            this.journalType = "知识库管理=>知识库列表=>添加";
            this.menuId = "6_2-7";
            this.tittle = '';
            this.baseId = this.selectTreeIdForContent;
            this.content = '';
            this.isUpInt = '0';
            this.description = '';
            this.title = '添加知识库内容';
            this.modelHeight = {'maxHeight': '', 'marginTop': '20px'};
          }
        }
      }
    },
    mounted() {
      autotip:{
        document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
        for (let item of this.toolbarTips) {
          let tip = document.querySelector('.quill-editor ' + item.Choice)
          if (!tip) continue
          tip.setAttribute('title', item.title)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/KnowledgeContentPop.vue